import React, { useEffect, useState, Fragment } from 'react';
import { trackFbEvent } from '../utils/fbPixel';
const comparisonRows = [{
  without: 'Resúmenes dispersos',
  with: 'Todo organizado por materia'
}, {
  without: 'Estudiás de cero cada parcial',
  with: 'Tomos y protocolos listos'
}, {
  without: 'Finales sin un plan claro',
  with: 'Guía y banco de preguntas'
}, {
  without: 'TPs que te llevan horas',
  with: 'Fichas listas para adaptar'
}, {
  without: 'Cursada desordenada',
  with: 'Planner y seguimiento editable'
}, {
  without: 'Improvisación constante',
  with: 'Sistema completo para avanzar'
}];
const TIMER_KEY = 'megapack_kinesiologia_countdown_end';
const DURATION_MS = 24 * 60 * 60 * 1000;
function getEndTime(): number {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS;
  const stored = localStorage.getItem(TIMER_KEY);
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + DURATION_MS;
  localStorage.setItem(TIMER_KEY, String(end));
  return end;
}
function getTimeLeft(endTime: number) {
  const diff = Math.max(0, endTime - Date.now());
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(diff % (1000 * 60) / 1000);
  return {
    hours,
    minutes,
    seconds
  };
}
export function DarkCTA() {
  const [endTime] = useState<number>(() => getEndTime());
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(endTime));
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft(endTime));
    }, 1000);
    return () => clearInterval(timer);
  }, [endTime]);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-16 sm:py-20 text-gray-900 text-base leading-6" style={{
    background: 'linear-gradient(180deg, rgb(219,234,254) 0%, rgb(255,255,255) 30%, rgb(255,255,255) 70%, rgb(219,234,254) 100%)'
  }} data-id="element-95">
      <div className="mx-auto max-w-4xl text-center" data-id="element-96">
        {/* Brand */}
        <div className="mb-8 sm:text-3xl font-black tracking-[3px] text-blue-700 text-[18px]" data-id="element-97">
          🦴 MEGAPACK KINESIOLOGÍA CARRERA RESUELTA™
        </div>

        {/* Headlines */}
        <h2 className="text-xl sm:text-3xl font-bold text-gray-900 m-0 mb-3" data-id="element-98">
          El próximo parcial podés volver a improvisar.
        </h2>
        <p className="text-xl sm:text-3xl font-black text-blue-700 m-0 mb-10" data-id="element-99">
          O podés entrar con todo resuelto desde hoy.
        </p>

        {/* Comparison Table */}
        <div className="mx-auto max-w-2xl mb-12 overflow-hidden rounded-2xl border border-gray-200 text-left" style={{
        backgroundColor: 'rgb(255,255,255)'
      }} data-id="element-100">
          {/* Table Title */}
          <div className="text-center font-bold text-gray-900 border-b border-gray-200 px-4 py-4" style={{
          backgroundColor: 'rgb(243,244,246)'
        }} data-id="element-101">
            ¿Cuánto cuesta NO tenerlo?
          </div>

          {/* Table Header */}
          <div className="grid grid-cols-2 border-b border-gray-200" style={{
          backgroundColor: 'rgb(243,244,246)'
        }} data-id="element-102">
            <div className="text-center font-bold text-gray-500 px-4 py-3 text-sm" data-id="element-103">
              SIN MEGAPACK
            </div>
            <div className="text-center font-bold text-blue-700 border-l border-gray-200 px-4 py-3 text-sm" data-id="element-104">
              CON MEGAPACK
            </div>
          </div>

          {/* Rows */}
          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-105">
              <div className="px-4 py-3 text-xs sm:text-sm text-gray-500" data-id="element-106">
                ✗ {row.without}
              </div>
              <div className="px-4 py-3 text-xs sm:text-sm font-bold text-gray-900 border-l border-gray-100" style={{
            backgroundColor: 'rgba(59,130,246,0.05)'
          }} data-id="element-107">
                ✓ {row.with}
              </div>
            </div>)}
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-108">
          <p className="font-bold text-gray-900 m-0 mb-4" data-id="element-109">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="flex items-center justify-center gap-0" data-id="element-110">
            {[{
            value: timeLeft.hours,
            label: 'hs'
          }, {
            value: timeLeft.minutes,
            label: 'min'
          }, {
            value: timeLeft.seconds,
            label: 'seg'
          }].map((item, i) => <Fragment key={item.label} data-id="element-111">
                <div className="flex flex-col items-center" data-id="element-112">
                  <span className="text-5xl sm:text-7xl font-black tabular-nums" style={{
                color: 'rgb(255,68,68)'
              }} data-id="element-113">
                    {pad(item.value)}
                  </span>
                  <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-114">
                    {item.label}
                  </span>
                </div>
                {i < 2 && <span className="mb-4 text-5xl sm:text-7xl font-black" style={{
              color: 'rgb(255,68,68)'
            }} data-id="element-115">
                    :
                  </span>}
              </Fragment>)}
          </div>
        </div>

        <p className="text-sm text-gray-600 m-0 mb-12" data-id="element-116">
          Después sube{' '}
          <span className="font-bold text-red-500" data-id="element-117">$15.000 ARS</span> y no
          vuelve.
        </p>

        {/* Two Pricing Cards */}
        <div className="mx-auto max-w-2xl mb-10 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-118">
          {/* Standard */}
          <div className="flex flex-col rounded-xl p-6 border border-gray-200 shadow-sm" style={{
          backgroundColor: 'rgb(255,255,255)'
        }} data-id="element-119">
            <div className="mb-2 text-2xl" data-id="element-120">🦴</div>
            <h3 className="text-base font-black text-gray-900 m-0 mb-1" data-id="element-121">
              MEGAPACK BASE
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-122">
              6 Tomos + 6 Bonos · Toda la carrera organizada
            </p>
            <div className="mt-auto" data-id="element-123">
              <p className="text-sm text-gray-500 line-through m-0 mb-1" data-id="element-124">
                Antes: $58.990 ARS
              </p>
              <p className="text-2xl font-black text-blue-700 m-0 mb-4" data-id="element-125">
                Hoy: $22.990
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48273779458218:1" onClick={() => {
              trackFbEvent('InitiateCheckout', {
                content_name: 'MegaPack Base',
                content_category: 'Kinesiología Carrera Resuelta',
                value: 22990,
                currency: 'ARS'
              });
            }} className="block bg-blue-700 text-white text-center text-sm font-black rounded-lg py-4 no-underline hover:opacity-90 transition-opacity" data-id="element-126">
                → QUIERO MI MEGAPACK BASE
              </a>
            </div>
          </div>

          {/* Pro */}
          <div className="flex flex-col rounded-xl p-6 border-2 border-blue-700 shadow-sm" style={{
          backgroundColor: 'rgb(239,246,255)',
          boxShadow: 'rgba(59,130,246,0.15) 0px 0px 30px 0px'
        }} data-id="element-127">
            <div className="mb-2 text-2xl" data-id="element-128">🏆</div>
            <h3 className="text-base font-black text-blue-700 m-0 mb-1" data-id="element-129">
              MEGAPACK BASE + KIT EDITABLE ⭐
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-1" data-id="element-130">La más elegida</p>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-131">
              6 Tomos + 6 Bonos + Kit Editable de Organización Académica
              <br data-id="element-132" />
              (planner, calendario y seguimiento)
            </p>
            <div className="mt-auto" data-id="element-133">
              <p className="text-sm text-gray-500 line-through m-0 mb-1" data-id="element-134">
                Antes: $102.990 ARS
              </p>
              <p className="text-3xl font-black text-blue-700 m-0 mb-4" data-id="element-135">
                Hoy: $29.990
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48273779523754:1" onClick={() => {
              trackFbEvent('InitiateCheckout', {
                content_name: 'MegaPack Base + Kit Editable de Organización Académica',
                content_category: 'Kinesiología Carrera Resuelta',
                value: 29990,
                currency: 'ARS'
              });
            }} className="block bg-blue-700 text-white text-center text-sm font-black rounded-lg py-4 no-underline hover:opacity-90 transition-opacity" data-id="element-136">
                → QUIERO EL MEGAPACK + KIT EDITABLE
              </a>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-600" data-id="element-137">
          <span data-id="element-138">🔒 Pago 100% seguro</span>
          <span data-id="element-139">⚡ Acceso en 5 minutos</span>
          <span data-id="element-140">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-141">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>
      </div>
    </section>;
}